import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Button, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import boardServices from '../../services/boardServices';
import ImageWithFallback from '../ImageWithFallback';
import AlertDialogSlide from '../../shared/popup';
import { sortBoardMembersByRank } from '../../section/board/constants';

const BoardSection = styled(Box)(({ theme }) => ({
  padding: '1.5rem 0',
  backgroundColor: '#f8f8f8'
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '36px',
  marginBottom: '40px',
  color: '#333',
  textAlign: 'center',
  fontWeight: '500'
}));

const MembersGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
  gap: '30px',
  marginBottom: '40px',
  padding: '0 20px'
}));

const MemberCard = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  '& img': {
    width: '180px',
    height: '180px',
    borderRadius: '50%',
    marginBottom: '15px',
    objectFit: 'cover'
  },
  '& h3': {
    fontSize: '20px',
    color: '#333',
    margin: '0 0 5px 0'
  },
  '& p': {
    fontSize: '16px',
    color: '#666',
    margin: 0,
    fontStyle: 'italic'
  }
}));

// Format as "15 February, 2025"
const formatBoardDate = (date) => {
  if (!date) return "—";
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return "—";
  const day = d.getDate();
  const month = d.toLocaleDateString("en-US", { month: "long" });
  const year = d.getFullYear();
  return `${day} ${month}, ${year}`;
};

const getStartDate = (member) => {
  if (!member) return null;
  if (member.effectiveStartDate || member.startDate || member.createdAt) {
    return member.effectiveStartDate || member.startDate || member.createdAt;
  }
  const id = member._id;
  if (!id) return null;
  const hex = typeof id === "string" ? id : (id?.toString && id.toString());
  if (!hex || hex.length < 8) return null;
  const sec = parseInt(hex.slice(0, 8), 16);
  if (Number.isNaN(sec)) return null;
  return new Date(sec * 1000).toISOString();
};

const BoardMembers = ({ members }) => {

  const [data, setData] = useState([])

  const [open, setOpen] = useState(false)

  const getData = () => {
    boardServices
      .getCurrent()
      .then((res) => {
        const list = res?.data?.data || [];
        setData(sortBoardMembersByRank(list));
      })
      .catch(() => setData([]));
  };

  useEffect(() => {
    getData();
  }, [])

  return (
    <BoardSection component="section" id="board">
      <Typography
        variant="h4"
        fontWeight="bold"
        textAlign="center"
        gutterBottom
        color="rgba(26,128,200)"

      >
        Our Board Members
      </Typography>
      {/* <SectionTitle variant="h2">
       
      </SectionTitle> */}
      <MembersGrid>
        {data?.slice(0, 5)?.map((member) => (
            <MemberCard key={member._id}>
            <ImageWithFallback
              path={member.image}
              alt={member.name}
              style={{
                objectFit: "contain",
                backgroundColor: "white"
              }}
            />
            <Typography variant="h3">{member.name}</Typography>
            <Typography variant="body1">{member.title}</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {formatBoardDate(getStartDate(member))} – Current
            </Typography>
          </MemberCard>
        ))}
      </MembersGrid>
      <Box sx={{ textAlign: 'center', mt: 2 }}>
        <Button
          component={Link}
          to="/board-members"
          variant="outlined"
          color="primary"
          endIcon={<ArrowForwardIcon />}
          size="large"
        >
          View all board members
        </Button>
      </Box>
      <AlertDialogSlide
        open={open}
        setOpen={setOpen}
        fullWidth
        maxWidth="md"

      >
        <Stack px={{ xs: '10px', md: '30px' }} py={{ xs: '10px', md: '18px' }} spacing={1}>

          <MembersGrid>
            {data?.map((member) => (
              <MemberCard key={member._id}>
                <ImageWithFallback
                  path={member.image}
                  alt={member.name}
                />
                <Typography variant="h3">{member.name}</Typography>
                <Typography variant="body1">{member.title}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                  {formatBoardDate(getStartDate(member))} – Current
                </Typography>
              </MemberCard>
            ))}
          </MembersGrid>

        </Stack>
      </AlertDialogSlide>
    </BoardSection>
  );
};

export default BoardMembers; 